import React, { act, ChangeEvent, useEffect, useRef, useState } from "react";
import Appservice from "../../services/appservice";
import { useParams } from "react-router-dom";
import { catchError } from "../../utils/Utils";
import { AxiosError } from "axios";
import questionsData from "../../data/ApplicationData";
import checkedRadiobutton from "../../images/checkedRadio.svg";
import radiobutton from "../../images/radioicon.svg";
import "./questions.scss";
import { Input } from "reactstrap";
import { FixedSizeList as List } from "react-window";
import disableRadioIcon from "../../images/disabled-radio.svg";
import DropdownInput from "../../commonfields/inputs/DropdownInput";
import { useLocation } from 'react-router-dom';
import Autosizer from 'react-virtualized-auto-sizer';

interface Question {
  questionId: number;
  questionText: string;
}

interface Subcategory {
  subcategoryName: string;
  questions: Question[];
}

interface ParentCategory {
  parentCategoryName: string;
  subcategories: Subcategory[];
}
interface QuestionsProps {
  filterCategories: (parentcatg?: any) => void;
  getQuestionsList: () => void;
  activeCategory: string;
  allData: any;
  categories: any;
  questionnaireData: [] | ParentCategory[];
  setSelectedQuestion: any;
  fields:any;
  preSelectQuestions: any;
  selectedQuestion:any;
};

window.HTMLElement.prototype.scrollIntoView = function() {};

const Questions = (props: QuestionsProps) => {
  const [showDescription, setShowDescription] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const questionSectionRef = useRef<any>(null);
  const listRef = React.useRef<any>(null);
  //let location = useLocation();
  const {
    filterCategories,
    getQuestionsList,
    activeCategory,
    allData,
    categories,
    questionnaireData,
  } = props;
  const { mappingId } = useParams();
  const preSelectQuestions = props.preSelectQuestions || [];

  useEffect(()=>{
       setSelectedOption(props.selectedQuestion)
   }, [props.selectedQuestion])

  useEffect(()=>{
     // if(props.preSelectQuestions &&  props.preSelectQuestions.length && listRef && listRef.current){
        //window.location.hash = "questions_section"+"_"+props.preSelectQuestions[0];
        //document.getElementById(props.preSelectQuestions[0])?.scrollIntoView();
        //questionSectionRef?.current?.scrollIntoView()
      if(props.preSelectQuestions &&  props.preSelectQuestions.length && listRef && listRef.current){
        listRef.current.scrollTo(-10);
      }
  }, [props.preSelectQuestions])
  const handleOptionChange = (id: any) => {
    if(selectedOption == id){
      setSelectedOption(null);
      props.setSelectedQuestion(null);
    } else {
      setSelectedOption(id);
      props.setSelectedQuestion(id);
    }
   
  };

  const handleShowDescription = (id: any) => {
    setShowDescription(!showDescription);
  };

  const service = new Appservice();
  //const { mappingId } = useParams();

  // funcs-Api call

  // funcs - render
  // useEffect
  useEffect(() => {
    filterCategories();
  }, [props.allData]);
  useEffect(() => {
    getQuestionsList();
  }, []);

  const changeCategory = (e: any) => {
    filterCategories(e.target.value);
  };

  const isFieldAvailable = (fields:any = {}, leftFields:any=[])=>{
      const _fs = Object.keys(fields);
      for(let k=0; k<_fs.length; k++){
         const found = fields[_fs[k]].find((f2:any)=> leftFields.find((lf:any)=>lf.field_id === f2.id));
         if(found){
           return true;
         } 
      }
      return false;
  }

  const renderCheckedButton = (q:any)=>{

    if(selectedOption === q.questionId || preSelectQuestions.includes(q.questionId)){
      return <img
      src={checkedRadiobutton}
      alt={q.questionId}
      id={q.questionId + ""}
    />
    } else if(q.fields && q.fields.length && isFieldAvailable(props.fields, q.fields)){
      return <img
      src={disableRadioIcon}
      alt={q.questionId}
      id={q.questionId + ""}
    />

    } else {
      return <img
      src={radiobutton}
      alt={q.questionId}
      id={q.questionId + ""}
      />
    }
  
  }
  return (
    <div className="category" style={{ position: "relative" }}>
      <div className="categoryFilter" style={{ position: "relative" }}>
        <div className="header">Category:</div>
        <Input
        className="filter-inputbox"
          id="categoryFilter"
          name="categoryFilter"
          type="select"
          onChange={changeCategory}
          //width={150}
        >
          {categories.map((c: any) => (
            <option>{c}</option>
          ))}
        </Input>
      
      </div>
      <div
        
       
        className="questionnaire"
        style={{ position: "relative", height: "100%" }}
      >
        {/* <Autosizer>
          {({height, width}:any)=> */}
        <List
          height={700}
          itemCount={questionnaireData.length}
          itemSize={70}
          ref={listRef} 
          className="questions_section"
          width={'100%'}
          style={{ position: "relative" }}
        >
          {({ index, style }: any) => {
            const question: any = questionnaireData[index] || {};
            return (
              <div style={style} className="question-list">
                <div className="question-item"  onClick={() => handleOptionChange(question.questionId)}>
                  <div
                    key={index}
                    className={`question${
                      (selectedOption === question.questionId || preSelectQuestions.includes(question.questionId)) ? "id-select" : ""
                    }`}
                  >
                    <div className="id-text">
                      <div className="question-id">{question.questionId}</div>
                      <div className="question-text">
                        {question.questionText}
                      </div>
                    </div>
                    {/* <div className="question-description">
                    <div className="description" onClick= {handleShowDescription}>View Description</div>
                    { question.questionId && showDescription ? <div className="show-description">{question?.description}</div>:""}
                  </div> */}
                  </div>
                </div>
                <div
                  className="radio"
                  onClick={() => handleOptionChange(question.questionId)}
                >
                 {renderCheckedButton(question)}
                </div>
              </div>
            );
          }}
        </List>
        {/* }
        </Autosizer> */}
      </div>{" "}
    </div>
  );
};

export default Questions;
